import { Loader2, Trash2 } from "lucide-react";

/** Fixo no pé do diálogo, que rola: salvar não pode depender de rolar até o fim dos materiais. */
export function RodapeDoServico({
  editando,
  salvando,
  podeSalvar,
  excluindo,
  onExcluir,
  onCancelar,
  onSalvar,
}: {
  editando: boolean;
  salvando: boolean;
  podeSalvar: boolean;
  excluindo: boolean;
  onExcluir: () => void;
  onCancelar: () => void;
  onSalvar: () => void;
}) {
  return (
    <div className="sticky -bottom-6 z-10 -mx-6 -mb-6 flex items-center gap-2 border-t border-zinc-200 bg-white px-6 py-4 dark:border-border dark:bg-card">
      {editando && (
        <button
          type="button"
          onClick={onExcluir}
          disabled={excluindo}
          className="inline-flex h-10 items-center gap-1.5 rounded-md border border-red-200 bg-red-50 px-3 text-sm font-medium text-red-600 hover:bg-red-100 disabled:opacity-50 dark:border-red-500/30 dark:bg-red-500/10 dark:text-red-400"
        >
          {excluindo ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash2 className="h-4 w-4" />}
          <span className="hidden sm:inline">Excluir serviço</span>
          <span className="sm:hidden">Excluir</span>
        </button>
      )}
      <div className="ml-auto flex gap-2">
        <button
          type="button"
          onClick={onCancelar}
          className="inline-flex h-10 items-center rounded-md border border-zinc-200 px-4 text-sm font-medium text-zinc-600 hover:bg-zinc-50 dark:border-border dark:text-muted-foreground"
        >
          Cancelar
        </button>
        <button
          type="button"
          disabled={salvando || !podeSalvar}
          onClick={onSalvar}
          className="inline-flex h-10 items-center gap-1.5 rounded-md bg-brand-600 px-4 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-brand-700 disabled:opacity-50"
        >
          {salvando && <Loader2 className="h-4 w-4 animate-spin" />}
          {editando ? "Salvar alterações" : "Adicionar serviço"}
        </button>
      </div>
    </div>
  );
}
